<div
  [attr.tabindex]="disabled() ? null : 0"
  (blur)="onTouched()"
  (keydown)="onKeyDown($event)"
  class="radio-group"
>
  @for (item of items(); track trackByItem($index, item)) {
    <div [class.checked]="isChecked(item)" (click)="onClick(item)" class="radio-container">
      <ng-template
        [ngTemplateOutlet]="item.template || itemTemplate"
        [ngTemplateOutletContext]="{ $implicit: item, currentValue: value }"
      />
    </div>
  }
</div>

<ng-template #optionDefaultTemplate let-item>
  <rt-radio-form-group-item [item]="item" [icon]="icon()" [disabled]="disabled()" />
</ng-template>
